Librarian.Modules.Links = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-links-",
        links: [],
        fileName: null,
        text: null,
        type: "href"
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || !this.options.links)
            return;

        var text = this.options.text;

        this.parent();
        var listEl = new Element("ul", {
            "class": (this.options.classPrefix || '') + "list"
        }).injectInside(this.containerEl);

        if (typeof this.options.fileName == "string") {
            // Generate the URL
            var url = Librarian.path.getMethodUrl("getslidetext") + "&out=ujson&snum=1&fname=" + encodeURIComponent(this.options.fileName);

            this.request = new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    if (!json)
                        return;
                    text = json.Text;
                    new Element("div", {
                        "html": Librarian.Lang.getString(text),
                        "class": (this.options.classPrefix || '') + "text"
                    }).injectTop(this.containerEl);
                }.bind(this),
                onFailure: Librarian.Utils.onFailure
            });
            this.request.send();
        }

        if (text) {
            if (typeof text == "string" && text.length > 0) {
                new Element("div", {
                    "html": Librarian.Lang.getString(text),
                    "class": (this.options.classPrefix || '') + "text"
                }).injectTop(this.containerEl);
            }
        }

        for (var i = 0; i < this.options.links.length; i++) {
            var link = this.options.links[i];

            if (Object.keys(link).length == 0)
                continue;

            var linkEl = new Element("li", {
                "class": (this.options.classPrefix || '') + "link " + (link.className || '')
            }).injectInside(listEl);

            if (link.iconHTML) {
                new Element("span", {
                    "html": link.iconHTML
                }).injectInside(linkEl);
            }

            new Element("span", {
                "html": link.name
            }).injectInside(linkEl);

            if (link.overlayClass) {
                new Element("div", {
                    'class': link.overlayClass
                }).injectInside(linkEl);
            }

            if (this.options.type == "href") {
                if (typeof link.onClick == "function")
                    linkEl.addOnClick(link.onClick);
                else if (typeof link.href == "string") {
                    linkEl.href = link.href;
                    linkEl.target = link.target || "_blank";
                    linkEl.addOnClick(function() {
                        window.open(this.href, this.target);
                    });
                }
            } 
            else if (this.options.type == "html") {
                this.addOnClick(link.fileName, link.name, linkEl);              
            }
        }
    },

    addOnClick: function(fileName, name, linkEl) {
        Librarian.Utils.getSlideText({ filename:fileName, slidenumber: 0 }, function(data) {
            linkEl.addOnClick(function() {
                new Librarian.HTMLWindow({
                    title: name,
                    html: data.Text
                });
            });
        });
    }
});